export default __webpack_public_path__ + "static/media/map.421a8ead.svg";